module.exports = __webpack_public_path__ + "img/pinterest.1a9ceaa7.svg";